import type { RubricItem } from '../../core/rubric';

export interface ItemEditorProps {
  item: RubricItem;
  index: number;
  count: number;
  onChange: (item: RubricItem) => void;
  onRemove: () => void;
  onMove: (direction: -1 | 1) => void;
  onManageLevels: () => void;
}

export default function ItemEditor({ item, index, count, onChange, onRemove, onMove, onManageLevels }: ItemEditorProps) {
  return (
    <div className="focused-criterion">
      <p className="editor-eyebrow">Criterion {index + 1} of {count}</p>
      <h3>What does good look like?</h3>
      <label className="field">Criterion name
        <input className="ph-mask" value={item.name} onChange={e => onChange({ ...item, name: e.target.value })} placeholder="Name this criterion" />
      </label>
      <label className="field">What this criterion measures
        <textarea className="ph-mask" rows={3} value={item.description} onChange={e => onChange({ ...item, description: e.target.value })} />
      </label>
      <div className="pane-head"><h4>Performance levels</h4><button type="button" className="link small" onClick={onManageLevels}>Manage shared levels</button></div>
      <p className="hint">Ordered from lowest to highest. Descriptions are optional, but they make scores sharper.</p>
      <ol className="focused-levels">
        {item.levels.map((level, i) => (
          <li key={i}>
            <label className="field"><span><span className="level-number">{i + 1}</span>{level.name || `Level ${i + 1}`}</span>
              <textarea className="ph-mask" aria-label={`${level.name || `Level ${i + 1}`} description`} value={level.text} rows={5}
                placeholder={`Optional. What does ${level.name || 'work at this level'} look like for this criterion? Left blank, it is scored by the level name.`}
                onChange={e => onChange({ ...item, levels: item.levels.map((l, j) => j === i ? { ...l, text: e.target.value } : l) })} />
            </label>
          </li>
        ))}
      </ol>
      <div className="criterion-tools">
        <button type="button" className="secondary small" disabled={index === 0} onClick={() => onMove(-1)}>Move criterion up</button>
        <button type="button" className="secondary small" disabled={index === count - 1} onClick={() => onMove(1)}>Move criterion down</button>
        <button type="button" className="link small" disabled={count === 1} onClick={onRemove}>Remove criterion</button>
      </div>
    </div>
  );
}
